export const PROJECT_LIST_SET_LOADING = "PROJECT_LIST_SET_LOADING";
export const PROJECT_LIST_SET_PROJECTS = "PROJECT_LIST_SET_PROJECTS";
